import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, LOCALE_ID } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";
import { routes } from "./app.routes";
import { portalApiInterceptor } from "./visitors/services/portal-api.interceptor";
import { AvailableLocales } from "types/enums/available-locales.enum";
import { LOCALE } from "types/constants/local-storage-keys";
import { MessageService } from "primeng/api";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([portalApiInterceptor])),
    {
      provide: LOCALE_ID,
      useFactory: () => {
        const validLocales = Object.values(AvailableLocales).filter((value) => typeof value === "string") as string[];
        const localeCurrent = localStorage.getItem(LOCALE) || null;
        return localeCurrent && validLocales.includes(localeCurrent) ? localeCurrent : AvailableLocales.English;
      },
    },
    MessageService,
  ],
};
